export default "__VITE_ASSET__B2o9hck1__"